// src/components/PeoplePlan/TheBench/components/WorkflowControls/KanbanFilters.js
import React from "react";

const KanbanFilters = ({ 
  filters, 
  onFilterChange, 
  onReset, 
  getUniqueValues,
  selectedStatuses,
  onStatusChange,
  isIntegrated 
}) => {
  const filterConfigs = [
    { field: "employee_name", label: "Employee", id: "bench-employee-filter" },
    { field: "mum_name", label: "MUM", id: "bench-mum-filter" },
    { field: "workflow_name", label: "Workflow", id: "bench-workflow-filter" },
    { field: "corp", label: "Location", id: "bench-location-filter" }
  ];

  const statusOptions = ["All", "New", "In Progress", "Completed", "Rejected"];
  const hasActiveFilters = Object.values(filters).some(v => v !== "all");

  return (
    <div className="bench-filters-section">
      {filterConfigs.map(config => (
        <div key={config.field} className="bench-filter-item">
          <label htmlFor={config.id}>{config.label}</label>
          <select
            id={config.id}
            className="bench-filter-select"
            value={filters[config.field]}
            onChange={(e) => onFilterChange(config.field, e.target.value)}
            style={{ fontSize: '14px', padding: '10px 30px 10px 12px' }}
          >
            <option value="all">All {config.label}s</option>
            {getUniqueValues(config.field).map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
      ))}

      {/* Add Status dropdown when integrated */}
      {isIntegrated && (
        <div className="bench-filter-item">
          <label htmlFor="status-filter">Status</label>
          <select
            id="status-filter"
            className="bench-filter-select"
            value={selectedStatuses.length === 4 ? "All" : selectedStatuses[0] || "All"}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "All") {
                onStatusChange(["New", "In Progress", "Completed", "Rejected"]);
              } else {
                onStatusChange([value]);
              }
            }}
            style={{ fontSize: '14px', padding: '10px 30px 10px 12px' }}
          >
            {statusOptions.map(status => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>
      )}

      {hasActiveFilters && (
        <button
          className="bench-reset-filters"
          onClick={onReset}
          title="Reset all filters"
        >
          ✕ Reset
        </button>
      )}
    </div>
  );
};

export default KanbanFilters;